import { Text } from '@viapeople/components'
import type React from 'react'

interface RejectionBannerProps {
	rejectionReason?: string | null
	rejectedBy?: string | null
}

export const RejectionBanner: React.FC<RejectionBannerProps> = ({ rejectionReason, rejectedBy }) => {
	return (
		<div className='bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6'>
			<div className='flex items-start gap-3'>
				<div className='flex-shrink-0'>
					<svg
						className='w-5 h-5 text-amber-600 mt-0.5'
						fill='currentColor'
						viewBox='0 0 20 20'
						xmlns='http://www.w3.org/2000/svg'
						aria-hidden='true'>
						<path
							fillRule='evenodd'
							d='M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z'
							clipRule='evenodd'
						/>
					</svg>
				</div>
				<div className='flex-1'>
					<Text variant='small' weight='regular' className='text-amber-800 mb-1'>
						This evaluation was rejected by {rejectedBy}.
					</Text>
					{rejectionReason ? (
						<Text variant='small' className='text-amber-700'>
							Reason: {rejectionReason}
						</Text>
					) : (
						<Text variant='small' className='text-amber-700'>
							No reason was provided for the rejection.
						</Text>
					)}
				</div>
			</div>
		</div>
	)
}
